/* block */
(function() {
  try {
    var CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid'];
    var urlParams = new URLSearchParams(window.location.search);

    CLICK_ID_KEYS.forEach(function(key) {
      var val = urlParams.get(key);
      if (val) {
        // Store in localStorage with 90-day expiry (Google Ads window)
        var data = {
          value: val,
          timestamp: new Date().getTime(),
          expiry: new Date().getTime() + (90 * 24 * 60 * 60 * 1000)
        };
        localStorage.setItem('fw_' + key, JSON.stringify(data));
        // Also set a cookie as fallback
        var expDate = new Date();
        expDate.setDate(expDate.getDate() + 90);
        document.cookie = 'fw_' + key + '=' + val + '; expires=' + expDate.toUTCString() + '; path=/; SameSite=Lax';
      }
    });

    function getFWClickId(key) {
      try {
        var stored = localStorage.getItem('fw_' + key);
        if (stored) {
          var data = JSON.parse(stored);
          if (data.expiry > new Date().getTime()) {
            return data.value;
          }
          localStorage.removeItem('fw_' + key);
        }
      } catch(e) {}
      // Fallback: check cookie
      var match = document.cookie.match(new RegExp('fw_' + key + '=([^;]+)'));
      return match ? match[1] : null;
    }
    // Expose gclid getter for use in forms/checkout (kept for back-compat)
    window.getFWGclid = function() { return getFWClickId('gclid'); };
    window.getFWClickId = getFWClickId;

    // Auto-populate hidden click-id fields in any form with matching name/id
    document.addEventListener('DOMContentLoaded', function() {
      CLICK_ID_KEYS.forEach(function(key) {
        var val = getFWClickId(key);
        if (val) {
          var fields = document.querySelectorAll('input[name="' + key + '"], input[id="' + key + '"]');
          fields.forEach(function(f) { f.value = val; });
        }
      });
    });

    // Push captured click IDs into cart attributes so they land on draft/order note_attributes
    // (same /cart/update.js pattern as the FW_META_ATTRIBUTION_CAPTURE_V1 fbclid block above)
    var gclidVal = getFWClickId('gclid');
    var gbraidVal = getFWClickId('gbraid');
    var wbraidVal = getFWClickId('wbraid');
    if (gclidVal || gbraidVal || wbraidVal) {
      var cartAttrs = { attributes: {
        gclid: gclidVal || '',
        gbraid: gbraidVal || '',
        wbraid: wbraidVal || ''
      }};
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/cart/update.js', new Blob([JSON.stringify(cartAttrs)], {type:'application/json'}));
      } else {
        fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(cartAttrs), keepalive:true});
      }
    }

  } catch(e) {}
})();
